import * as React from 'react';
const SvgLayers = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m15.683 13.758 1.967.967-7.642 3.758-7.641-3.758 1.966-.967-1.416-.7-1.967.967v1.392l9.058 4.458 9.059-4.458v-1.392l-1.967-.967c-.483.234-.75.367-1.417.7" />
    <path d="m15.142 9.033 2.5 1.234L10 14.025l-7.642-3.758 2.5-1.234-1.416-.7-2.5 1.234v1.391L10 15.417l9.058-4.459V9.567l-2.5-1.234c-.566.275-.725.359-1.416.7" />
    <path d="M10 .217.942 4.675v1.392L10 10.525l9.058-4.458V4.675zm0 8.916L2.358 5.375 10 1.617l7.642 3.758z" />
  </svg>
);
export default SvgLayers;
